import { useEffect, useRef, useState } from 'react';
import { retrieveSftyEduDtl } from '../../api/FnSmartTBM';
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';
import { Player, ControlBar, PlaybackRateMenuButton, BigPlayButton, PlayToggle, LoadingSpinner, CurrentTimeDisplay, TimeDivider, DurationDisplay, FullscreenToggle } from 'video-react';
import axios from "axios";
import { useDidMountEffect } from "../../hook/useDidMountEffect";

export default function SmrtTBMsftyEdu({ doneTBM, setSftyEduDtlData, setEduDataList, setReadSftyEduList, readSftyEduList, sftyEduDtlData, eduDataList, sctrGb, setSnackbarTxt, videoRef, doneHandler }: any) {
  const [eduData, setEduData] = useState<any>([]);
  const [backArrowState, setBackArrowState] = useState(true);
  const [forwardArrowState, setForwardArrowState] = useState(true);
  const [videoEnded, setVideoEnded] = useState(new Set());
  const inputRef = useRef<any>();
  const inputClick = () => { inputRef.current.click(); };

  useEffect(() => {
    if (doneTBM) {
      eduDataList.map((e: any, i: number) => { videoEnded.add(i); setVideoEnded(videoEnded); })
    }
  }, [])

  useEffect(() => {
    retrieveSftyEduDtl(sctrGb, setSftyEduDtlData, setEduDataList, setReadSftyEduList, readSftyEduList);
  }, [])
  useDidMountEffect(() => {
    if (Array.isArray(eduDataList) && eduDataList.length === 0) { doneHandler(); } // setAgrd((prevState: any) => ({ ...prevState, 5: true }))
    if (Array.isArray(eduDataList) && eduDataList.length === 1) { setBackArrowState(false); setForwardArrowState(false); }
  }, [eduDataList])

  const arrowHandler = (dir: string) => {
    let index = eduDataList.findIndex((i: any) => i.seq === sftyEduDtlData?.seq)
    if (videoEnded.has(index) === false) {
      if (videoRef.current && videoRef.current.getState().player.ended === false) {
        setSnackbarTxt('영상을 끝까지 시청해주세요.');
        return;
      } else {
        videoEnded.add(index);
        setVideoEnded(videoEnded);
      }
    }
    if (index !== 0 && dir === 'back') {
      setSftyEduDtlData({ title: eduDataList[index - 1].title, atchFileId: eduDataList[index - 1].atchFileId, seq: eduDataList[index - 1].seq })
    } else if (index !== eduDataList.length - 1 && dir === 'forward') {
      setSftyEduDtlData({ title: eduDataList[index + 1].title, atchFileId: eduDataList[index + 1].atchFileId, seq: eduDataList[index + 1].seq })
    }
  };

  useEffect(() => {
    let index = eduDataList.findIndex((i: any) => i.seq === sftyEduDtlData?.seq)
    if (index === 0) { setBackArrowState(false); setForwardArrowState(true); }
    else if (index !== 0 && index !== eduDataList.length - 1) { setBackArrowState(true); setForwardArrowState(true); }
    else if (index === eduDataList.length - 1) { setBackArrowState(true); setForwardArrowState(false); }
  }, [sftyEduDtlData]);

  useEffect(() => {
    setReadSftyEduList(readSftyEduList.concat(sftyEduDtlData?.seq))
    if (sftyEduDtlData) {
      fn_retrieveVideoData(sftyEduDtlData.atchFileId);
    }

  }, [sftyEduDtlData])

  useEffect(() => {
    var videos = window.document.getElementsByTagName("video")
    for (var i = 0; i < videos.length; i++) {
      videos[i].load()
    }
  }, [eduData])

  const fn_retrieveVideoData = async (atchFileId: any) => {
    const rtrnData = await axios.post('admin/api/cmmn/fileInfoForTableView', { atchFileId: atchFileId });
    let datas = rtrnData.data.fileList
    for (let i in datas) {
      datas[i].videoUrl = `admin/api/cmmn/fileDownload?atchFileId=${datas[i].atchFileId}&fileSn=${datas[i].fileSn}`
    }
    setEduData(datas);
  }


  return (
    <div className='flex flex-col justify-center items-center w-[260px] sm:w-[318px] md:w-[750px]'>
      {eduDataList?.length === 0 ? <p className='w-[90%] mt-32 text-15 leading-18 md:mt-[80px] md:text-37 md:leading-[45px] font-preBold'>등록된 안전교육이 없습니다.</p>
        : <>
          <p className='w-[90%] mt-32 text-15 leading-18 md:mt-[80px] md:text-37 md:leading-[45px] font-preBold'>제목<span className='ml-24 md:ml-[60px] font-preLight'>{sftyEduDtlData?.title}</span></p>
          <p className='w-[90%] mt-16 text-15 leading-18 md:mt-[40px] md:text-37 md:leading-[45px] font-preBold mb-17 md:mb-[42px]'>내용</p>
          <div className='w-[100%] flex justify-between items-center'>
            {eduDataList?.length === 1 ? <div className='text-30 md:text-75'>&nbsp;&nbsp;&nbsp;&nbsp;</div>
              : backArrowState ? <IoIosArrowBack className='text-30 md:text-75 text-[#C3C3C3]' onClick={() => arrowHandler('back')} /> : <div className='text-30 md:text-75'>&nbsp;&nbsp;&nbsp;&nbsp;</div>}
            <div className='w-[90%] flex flex-col justify-center'>{eduData.map((data: any) => (
              <Player autoPlay playsInline key={data.fileSn} ref={videoRef} >
                <source src={data?.videoUrl} type="video/mp4" />
                <LoadingSpinner />
                <BigPlayButton position="center" />
                <ControlBar autoHide={false} disableDefaultControls={true}>
                  <PlayToggle />
                  <CurrentTimeDisplay order={1} className='-translate-x-10' />
                  <TimeDivider order={1} className='-translate-x-15' />
                  <DurationDisplay order={1} className='-translate-x-21' />
                  <PlaybackRateMenuButton rates={[1, 1.5, 2]} />
                  <FullscreenToggle />
                </ControlBar>
              </Player>
              // <video autoPlay controls controlsList='nodownload' key={data.fileSn}>
              //   <source src={data?.videoUrl} type="video/mp4" />
              // </video>
            ))}
            </div>
            {eduDataList?.length === 1 ? <div className='text-30 md:text-75'>&nbsp;&nbsp;&nbsp;&nbsp;</div>
              : forwardArrowState ? <IoIosArrowForward className='text-30 md:text-75 text-[#C3C3C3]' onClick={() => arrowHandler('forward')} /> : <div className='text-30 md:text-75'>&nbsp;&nbsp;&nbsp;&nbsp;</div>}
          </div>
          {/*{!doneTBM && <div className='flex w-full mt-25 md:mt-[62px]'>*/}
          {/*  {!agrd[5] ? <input ref={inputRef} onChange={() => setAgrd((prevState: any) => ({ ...prevState, 5: !agrd[5] }))} type='checkbox' className='accent-point md:w-[40px]' />*/}
          {/*    : <input ref={inputRef} onChange={() => setAgrd((prevState: any) => ({ ...prevState, 5: !agrd[5] }))} type='checkbox' className='accent-point md:w-[40px]' defaultChecked />}*/}
          {/*  <p onClick={inputClick} className='ml-10 md:ml-[25px] text-[#9C9C9B] text-13 leading-15 md:text-35 md:leading-[35px] font-preLight underline underline-offset-1 decoration-[#9C9C9B] decoration-[0.5px]'>모든 안전교육 내용을 확인하고, 숙지하였습니다.</p>*/}
          {/*</div>}*/}
        </>
      }
    </div>
  );
}

